import { GettingStartedModule } from './pages/public/getting-started/getting-started.module';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
    NbAutocompleteModule,
    NbChatModule,
    NbDatepickerModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbTagModule,
    NbThemeModule,
    NbTimepickerModule,
    NbToastrModule,
    NbWindowModule
} from '@nebular/theme';
import { NgxLoginModule } from './pages/auth/login';
import { AuthGuard } from './shared/services/auth-guard.service';
import { NbAuthJWTInterceptor, NB_AUTH_TOKEN_INTERCEPTOR_FILTER } from '@nebular/auth';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LogoutModule } from './pages/auth/logout';
import { NgxResetPasswordModule } from './pages/auth/reset-password';
import { NgxRequestPasswordModule } from './pages/auth/request-password';
import { ContentTypeInterceptor } from './shared/interceptors/content-type.interceptor';
import { SentryErrorHandler } from './shared/services/sentry-error-handler.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import * as Cloudinary from 'cloudinary-core';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { reducers } from './pages/pages-state';
import { metaReducers } from './store/meta/meta.reducer';
import { CanLoadPagesGuard } from './shared/services/can-load-pages.guard';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { CustomSerializer } from './store/router/custom-route-serializer';
import { LocalisationEffects } from './store/localisation/localisation.effects';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { LocaleGuard } from './shared/locale-guard.service';
import { ApiModule, Configuration } from './shared/ordr-service-api';
import { environment } from 'environments/environment';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { HighchartsChartModule } from 'highcharts-angular';

@NgModule({
    declarations: [AppComponent],
    imports: [
        ApiModule.forRoot(() => new Configuration({ basePath: environment.server_url })),
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        LogoutModule,
        NgxRequestPasswordModule,
        NgxLoginModule,
        GettingStartedModule,
        NgxResetPasswordModule,
        NbDateFnsDateModule,
        ThemeModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbWindowModule.forRoot(),
        NbDialogModule.forRoot(),
        NbToastrModule.forRoot(),
        NbChatModule.forRoot({
            messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY'
        }),
        CoreModule.forRoot(),
        StoreModule.forRoot(reducers, { metaReducers }),
        EffectsModule.forRoot([LocalisationEffects]),
        StoreRouterConnectingModule.forRoot({
            serializer: CustomSerializer
        }),
        NgxChartsModule,
        TimepickerModule.forRoot(),
        TranslocoRootModule,
        NbTagModule,
        NbAutocompleteModule,
        NbTimepickerModule.forRoot(),
        HighchartsChartModule
    ],
    providers: [
        { provide: ErrorHandler, useClass: SentryErrorHandler },
        AuthGuard,
        CanLoadPagesGuard,
        LocaleGuard,
        { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ContentTypeInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
            useValue: req => {
                if (req.url === `${environment.server_url}/public/v1/refresh-token-admin`) {
                    return true;
                }
                return false;
            }
        },
        NbDialogModule
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
